






























import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
@Component({
  components: {
    PageTitle
  }
})
export default class PartnerRegister extends Vue {
}
